import React, { useState } from "react";
import { api, formatError } from "../api";

/**
 * Sign in / Sign up with LinkedIn button.
 *
 * Triggers the backend OIDC handshake by calling `/api/auth/linkedin/start`
 * and then redirecting the browser to LinkedIn. Falls back to a disabled
 * state if the server reports the LinkedIn integration as unconfigured.
 */
export default function LinkedInButton({ role, label = "Continue with LinkedIn", testId = "linkedin-login-btn" }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const onClick = async () => {
    setBusy(true); setErr("");
    try {
      const { data } = await api.get("/auth/linkedin/start", { params: role ? { role } : {} });
      if (!data?.authorization_url) throw new Error("No authorization URL");
      window.location.href = data.authorization_url;
    } catch (e) {
      setBusy(false);
      const msg = formatError(e);
      // Surface a friendly message when the server hasn't been configured yet
      if (msg && msg.toLowerCase().includes("not configured")) {
        setErr("LinkedIn sign-in is not configured yet. Ask the admin to add the LinkedIn credentials.");
      } else {
        setErr(msg || "Couldn't start LinkedIn sign-in.");
      }
    }
  };

  return (
    <div>
      <button
        type="button"
        onClick={onClick}
        disabled={busy}
        data-testid={testId}
        className="w-full flex items-center justify-center gap-2.5 px-4 py-3.5 rounded-2xl font-semibold text-sm border-2 bg-white text-[#0A66C2] border-[#0A66C2] transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.99] hover:shadow-[0_10px_24px_-12px_rgba(10,102,194,0.45)] disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="#0A66C2" d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM.22 8.25h4.56V24H.22zM8.75 8.25h4.37v2.13h.06c.61-1.16 2.1-2.38 4.32-2.38 4.62 0 5.47 3.04 5.47 6.99V24h-4.56v-7.17c0-1.71-.03-3.92-2.39-3.92-2.39 0-2.76 1.86-2.76 3.79V24H8.75z"/>
        </svg>
        {busy ? "Redirecting…" : label}
      </button>
      {err && (
        <p className="text-xs text-red-600 mt-2" data-testid="linkedin-btn-error">{err}</p>
      )}
    </div>
  );
}
